/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { FormulaElementType } from "abreact/expression/formula/framework/FormulaElementType";
// import ValidatedExpOperator = Expression.Domain.ValidatedExpOperator;

export class FormulaUtils {
  static getOperatorForElementType(elementType, expressionDomainModel, isStringEditor) {
    let operator;
    switch (elementType) {
      case FormulaElementType.OPERATOR_ADD:
        if (isStringEditor) {
          operator = expressionDomainModel.getExpOperator("add_string");
        } else {
          operator = expressionDomainModel.getExpOperator("add");
        }
        break;
      case FormulaElementType.OPERATOR_SUBTRACT:
        operator = expressionDomainModel.getExpOperator("subtract");
        break;
      case FormulaElementType.OPERATOR_MULTIPLY:
        operator = expressionDomainModel.getExpOperator("multiply");
        break;
      case FormulaElementType.OPERATOR_DIVIDE:
        operator = expressionDomainModel.getExpOperator("divide");
        break;
      default:
        throw new Error("Unable to find operator in domain for FormulaElementType:" + elementType);
    }

    // TODO: should validate that it has "left" and "right" operands (or make this configurable and validate)
    return operator;
  }
}
//# sourceMappingURL=FormulaUtils.js.map
